import React, { useEffect } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import hering_img from "../../../img/hearing-exam.jpg";
import hering_img2 from "../../../img/ear-measurements.jpg";
import hering_img3 from "../../../img/Hearing-Implants.jpg";
import hering_img4 from "../../../img/hearing-aids-Repair.jpg";
import "../Services/Service.css";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from 'react-helmet-async';

export default function HearingAidRepairs() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <>
        <Helmet>
      <title>Hearing Aid Repair | Hearing Aids Repairs & Services</title>
        <meta name="description" content="Is your hearing aid malfunctioning? Don't compromise your hearing! Contact us today for hearing aids repairs & services today!" />
        <meta property="og:title" content="Hearing Aid Repair | Hearing Aids Repairs & Services"></meta>
        <meta property="og:description" content="Is your hearing aid malfunctioning? Don't compromise your hearing! Contact us today for hearing aids repairs & services today!"></meta>
    </Helmet>
      <Header />
      <section className="hearing_service">
        <div className="container">
          <h1 className="Heading_text">Repairs & Adjustments</h1>
        </div>
      </section>

      <section className="Singapore">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-6  col-md-12">
              <div className="service_img">
                <img src={hering_img4} className="img-fluid" />
              </div>
            </div>
            <div className="col-xl-6  col-md-12">
              <div className="Sing_text">
                <h5>Hearing Aid Repairs and Adjustments</h5>
                <h1>Hearing Aid Repair Services in Singapore</h1>
                <p>
                  Hearing aids are small electronic devices that can be worn
                  inside the ear or behind the ear to amplify sounds in the
                  environment and speech. These small hearing devices require
                  great care and daily maintenance if they were to last at least
                  five years. Check out the hearing aid services provided by The
                  Hearing Centre Singapore, such as hearing aid repairs and
                  adjustments.
                </p>
                <p>
                  At The Hearing Centre Singapore, we take utmost care of your
                  hearing aids, whether they have worn out or been exposed to
                  any external environmental factor, physical damage, or
                  excessive ear wax. We provide full services for all hearing
                  aids from the brands we carry – Signia, Phonak, ReSound, and
                  Starkey. Routine servicing and hearing aid repairs can be sent
                  to the manufacturers through our centres. Volume adjustments
                  and reprogramming of hearing aids are also services provided
                  by The Hearing Centre Singapore.
                </p>
                <p>
                  Products required for regular and daily maintenance of your
                  hearing aids such as batteries, drying capsules, and wax
                  guards are also available at our centres.{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Other Services */}
      <section className="Other_Services">
        <div className="container">
          <h1 className="Heading_text">Other Services</h1>
          <div className="row">
            <div className="col-md-4">
              <div class="card">
                <img src={hering_img} class="card-img-top" alt="..." />
                <div class="card-body">
                  <Link className="" to="">
                    <h5 class="card-title">Hearing Tests</h5>
                  </Link>
                  <p class="card-text">
                    At The Hearing Centre, we work closely with individuals to
                    help them understand the type and degree of hearing problems
                    they have and become a companion with them on the path
                    towards better hearing.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div class="card">
                <img src={hering_img3} class="card-img-top" alt="..." />
                <div class="card-body">
                  <Link className="" to="">
                    <h5 class="card-title">Hearing Implants</h5>
                  </Link>

                  <p class="card-text">
                    Hearing implants, or Cochlear implants are small complex
                    devices that enable individuals with hearing losses to hear
                    the sounds around them.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div class="card">
                <img src={hering_img2} class="card-img-top" alt="..." />
                <div class="card-body">
                  <Link className="" to="">
                    <h5 class="card-title">Real-Ear Measurements</h5>
                  </Link>

                  <p class="card-text">
                    Our audiologists at The Hearing Centre provide facilities on
                    ear measurements to verify the level of hearing aids used by
                    the individuals.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
